import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#008896',
      main: '#008896',
      dark: '#008896',
      contrastText: '#fff',
    },
    secondary: {
      main: '#f44336',
    },
  },
});

export default theme;
